import { render, staticRenderFns } from "./consulRequest.vue?vue&type=template&id=51dff436"
import script from "./consulRequest.vue?vue&type=script&lang=js"
export * from "./consulRequest.vue?vue&type=script&lang=js"
import style0 from "./consulRequest.vue?vue&type=style&index=0&id=51dff436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports